import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const GenericUncloseableModalLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "GenericUncloseableModal" */
      './GenericUncloseableModal.dynamic'
    ),
  loading: LoadingModal,
});
